export const translationsToLocaleMap = (translations) => translations?.reduce((result, currentValue) => {
  const locale = currentValue?.language || 'en';
  result[locale] = currentValue;
  return result;
}, {});
